import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { lcApiBase, lcHttpError, lcStationId } from './logiciel-caisse-api.helper';
import { LogicielCaisseAuthService } from './logiciel-caisse-auth.service';

export interface TicketTemplateBlock {
  id: string;
  kind: 'field' | 'separator' | 'custom';
  fieldKey: string;
  label: string;
  order: number;
  visible: boolean;
  value?: string;
}

export interface TicketTemplateLayout {
  version: number;
  largeur_mm: number;
  blocks: TicketTemplateBlock[];
}

export interface TicketTemplateRow {
  ticket_type_id: number;
  code: string;
  libelle: string;
  ordre: number;
  template_id: number | null;
  largeur_mm: number;
  layout_json: TicketTemplateLayout;
  updated_at: string | null;
  is_default: boolean;
}

@Injectable({ providedIn: 'root' })
export class LogicielCaisseTicketTemplateService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: LogicielCaisseAuthService
  ) {}

  listForStation(): Observable<TicketTemplateRow[]> {
    const stationId = lcStationId(this.auth);
    const url = `${lcApiBase(this.auth)}/api/ticket-templates/station/${stationId}`;
    return this.http.get<{ success: boolean; items?: TicketTemplateRow[]; error?: string }>(url).pipe(
      map((res) => {
        if (!res?.success || !Array.isArray(res.items)) {
          throw new Error(res?.error || 'Réponse templates invalide');
        }
        return res.items;
      }),
      catchError((err) => throwError(() => lcHttpError(err, 'Chargement des templates ticket impossible.')))
    );
  }

  save(typeCode: string, layout: TicketTemplateLayout, largeur_mm?: number): Observable<TicketTemplateRow> {
    const stationId = lcStationId(this.auth);
    const url = `${lcApiBase(this.auth)}/api/ticket-templates/station/${stationId}/type/${encodeURIComponent(typeCode)}`;
    return this.http
      .put<{ success: boolean; data?: TicketTemplateRow; error?: string }>(url, {
        layout_json: layout,
        largeur_mm: largeur_mm ?? layout.largeur_mm,
      })
      .pipe(
        map((res) => {
          if (!res?.success || !res.data) {
            throw new Error(res?.error || 'Enregistrement impossible');
          }
          return res.data;
        }),
        catchError((err) => throwError(() => lcHttpError(err, 'Enregistrement du template impossible.')))
      );
  }
}
